/**
 * Detects if the current device is running iOS and adds an "is-ios" class to the html element
 */
function detectIOSDevice() {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  
  if (isIOS) {
    document.documentElement.classList.add('is-ios');
  }
}

// Run detection on page load
document.addEventListener('DOMContentLoaded', detectIOSDevice);

export default detectIOSDevice;